import styled from "styled-components"

export const StyledSpiral = styled.div`
  width: 187px;
  height: 500px;
  position: absolute;
  bottom: -35px;
  left: -15px;
  @media only screen and (max-width: 767px) {
    display: none;
  }
  img {
    width: 100%;
    height: 100%;
  }
`
